import { faExclamationCircle } from "@fullscript/pro-regular-svg-icons";
import { Trans, useTranslation } from "react-i18next";

import { FloatingLabelInput } from "@aviary";
import { e2eAttributes } from "@shared/e2eAttributes";
import { l } from "@shared/locales/i18n";

import { IconWrapper } from "../../IconWrapper/IconWrapper";
import * as styles from "../fields.styles";
import type { FieldProps } from "../types";

import AccountNumberSVGComponent from "./AccountNumber";

const AccountNumberField = ({ value, errors, onChange }: FieldProps) => {
  const { t } = useTranslation("settings");

  return (
    <IconWrapper
      icon={faExclamationCircle}
      tooltipMessage={
        <>
          <AccountNumberSVGComponent css={styles.tooltipSvg} />
          <Trans i18nKey={l.sharedSettings.tax.bankInfo.accountNumberTooltip}>
            Your <strong>account number</strong> is typically found on checks provided by your bank.
          </Trans>
        </>
      }
      tooltipPosition="bottom-end"
    >
      <FloatingLabelInput
        data-testid="account-number-input"
        type="text"
        id="accountNumber"
        value={value || ""}
        label={t(l.sharedSettings.tax.bankInfo.accountNumber)}
        required
        handleChange={onChange}
        errors={errors}
        data-e2e={e2eAttributes.paymentSettings.accountNumber}
      />
    </IconWrapper>
  );
};

export { AccountNumberField };
